import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { CheckCircle, XCircle, Loader2, BookOpen } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

export default function AcademyPaymentSuccess() {
  const [params] = useSearchParams();
  const { authFetch } = useAuth();
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying'); // verifying | success | error
  const [courseId, setCourseId] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    const sessionId = params.get('session_id');
    const cid = params.get('course_id') || '';
    setCourseId(cid);
    if (!sessionId || !cid) { setStatus('error'); setError('Parámetros de sesión inválidos'); return; }

    authFetch(`${API}/academy/payment/verify?session_id=${sessionId}&course_id=${cid}`)
      .then(r => r.json())
      .then(d => {
        if (d.success) { setStatus('success'); }
        else { setStatus('error'); setError(d.error || 'El pago no pudo ser verificado'); }
      })
      .catch(() => { setStatus('error'); setError('Error de conexión al verificar el pago'); });
  }, [params, authFetch]);

  return (
    <div className="min-h-screen bg-[#030712] flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-[#080F20] border border-[rgba(148,163,184,0.14)] rounded-3xl p-8 text-center space-y-6">
        {status === 'verifying' && (
          <>
            <Loader2 className="w-14 h-14 text-indigo-400 mx-auto animate-spin" />
            <h2 className="text-white text-xl font-bold">Verificando pago...</h2>
            <p className="text-[#94A3B8] text-sm">Por favor espera, estamos confirmando tu inscripción.</p>
          </>
        )}
        {status === 'success' && (
          <>
            <div className="w-20 h-20 rounded-full bg-emerald-500/20 border border-emerald-500/30 flex items-center justify-center mx-auto">
              <CheckCircle className="w-10 h-10 text-emerald-400" />
            </div>
            <div>
              <h2 className="text-white text-2xl font-black">¡Pago completado!</h2>
              <p className="text-[#94A3B8] text-sm mt-2">Tu inscripción ha sido confirmada. Ya puedes acceder al curso.</p>
            </div>
            <div className="flex flex-col gap-3">
              <button onClick={() => navigate(`/academy/aula/${courseId}`)}
                data-testid="go-to-classroom-btn"
                className="w-full py-3.5 rounded-2xl bg-indigo-600 hover:bg-indigo-500 text-white font-bold transition flex items-center justify-center gap-2">
                <BookOpen className="w-4 h-4" /> Ir al aula virtual
              </button>
              <Link to="/academy/mi-perfil" className="text-sm text-[#94A3B8] hover:text-white transition">
                Ver mis cursos
              </Link>
            </div>
          </>
        )}
        {status === 'error' && (
          <>
            <div className="w-20 h-20 rounded-full bg-red-500/20 border border-red-500/30 flex items-center justify-center mx-auto">
              <XCircle className="w-10 h-10 text-red-400" />
            </div>
            <div>
              <h2 className="text-white text-2xl font-black">Hubo un problema</h2>
              <p className="text-[#94A3B8] text-sm mt-2">{error}</p>
            </div>
            <div className="flex flex-col gap-3">
              <Link to={courseId ? `/academy/${courseId}` : '/academy'}
                className="w-full py-3.5 rounded-2xl bg-[rgba(148,163,184,0.1)] hover:bg-[rgba(148,163,184,0.15)] text-white font-bold transition flex items-center justify-center">
                Volver al curso
              </Link>
              <a href="mailto:academy@neuralia369.com" className="text-sm text-indigo-400 hover:text-indigo-300">
                ¿Problemas? Escríbenos a academy@neuralia369.com
              </a>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
